/// <reference path="../../../../Scripts/typings/breeze/breeze.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/services/networkmemberrepository',["require", "exports", "models/breeze", "services/settings"], function (require, exports, Data, Configuration) {
    "use strict";
    var NetworkMemberRepository = (function (_super) {
        __extends(NetworkMemberRepository, _super);
        function NetworkMemberRepository() {
            var serviceUrl = Configuration.Settings.getApiFor("breeze/networkmember");
            _super.call(this, serviceUrl);
        }
        NetworkMemberRepository.prototype.onMetadataRequested = function (store) {
            this.addNetworkMemberType(store);
        };
        NetworkMemberRepository.prototype.addNetworkMemberType = function (store) {
            var type = new breeze.ComplexType();
            type.shortName = "NetworkMember";
            type.namespace = "AIP.API.SocialNetwork.Model";
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Id", dataType: breeze.DataType.Guid, isNullable: false, isPartOfKey: true }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "OrganizationId", dataType: breeze.DataType.Guid, isNullable: false, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "Email", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "LoginName", dataType: breeze.DataType.String, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "LastLoggedIn", dataType: breeze.DataType.DateTime, isNullable: true, isPartOfKey: false }));
            type.addProperty(new breeze.DataProperty({ nameOnServer: "LoginCount", dataType: breeze.DataType.Int32, isNullable: true, isPartOfKey: false }));
            store.addEntityType(type);
        };
        return NetworkMemberRepository;
    }(Data.BreezeRepository));
    exports.NetworkMemberRepository = NetworkMemberRepository;
});

